var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-cabinet-requests-list"},[_c('div',{staticClass:"page-cabinet-requests-list__modes"},_vm._l((_vm.modes),function(mode,i){return _c('div',{key:i,staticClass:"page-cabinet-requests-list__modes-item",class:{
                _active: mode.code === _vm.activeMode,
                _accented: mode.isAccented,
            },domProps:{"textContent":_vm._s(mode.title)},on:{"click":function($event){return _vm.modeHandler(mode.code)}}})}),0),_c('div',{staticClass:"page-cabinet-requests-list__content"},[_c(_vm.currentComponent,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }